import { render } from "./DeviationReport.vue?vue&type=template&id=b2550806"
import script from "./DeviationReport.vue?vue&type=script&lang=js"
export * from "./DeviationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__